import { render, staticRenderFns } from "./StyleSettings.vue?vue&type=template&id=0fbcb45a&"
import script from "./StyleSettings.vue?vue&type=script&lang=js&"
export * from "./StyleSettings.vue?vue&type=script&lang=js&"
import style0 from "./StyleSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports